import { getAxiosApiV2WithAuthorization } from '@clatter/platform';

const ingestJobsApi = {
  fetchAll: () =>
    getAxiosApiV2WithAuthorization({
      url: `/ingest-jobs`,
    }),
};
export default ingestJobsApi;
